import React from 'react';
import uuidv4 from 'uuid';
import PropTypes from 'prop-types';

//material ui:
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import { Tooltip, Fade } from '@material-ui/core';

import { postData, putData } from '../../../dataLib';

const styles = theme => ({
    root: {
        height: '100%',
        width: 240
    },
    containerPair: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        minWidth: 520,
    },
    formControl: {
        display: 'flex',
        justifyContent: 'center',
        margin: '5px 25px',
        minWidth: 120,
        height: 72,
        width: 185,
    },
    buttonsContainer: {
        width: 520,
        padding: '25px 0 0 25px'
    },
    buttonsBottom: {
        marginRight: 15,
        padding: '10px 4%',
        borderRadius: 0,
        textTransform: 'capitalize',
        color: 'white',
        border: 'none',
        boxShadow: 'none',
    },
    margin: {
        marginTop: 10,
    },
    rtl: {
        textAlign: 'right',
    },
    tooltip: {
        fontSize: 14,
        color: "white",
        backgroundColor: '#3a3434',
        fontWeight: 200,
    },

});

class EditCodigoBarras extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            id: this.props.codigo.id ? this.props.codigo.id : 0,
            codBarras: this.props.codigo.codBarras ? this.props.codigo.codBarras : '',
            articuloCompraId: this.props.codigo.articuloCompraId
        }

    };

    handleValueChange = (event, field) => {
        this.setState({ ...this.state, [field]: event.target.value });

    };

    updateCodigoBarras = () => {

        let url = 'ArticuloCompraCodBarras'

        const codigo = { id: this.state.id, articuloCompraId: this.state.articuloCompraId, codBarras: this.state.codBarras };

        if (this.state.id === 0) { //nuevo codigo
            postData(url, () => {
                this.props.hideDialog();
                this.props.okHandler(codigo);
            },
                (error) => {
                    if (error.response.data.startsWith('REPETIDO')) {
                        this.props.openDialog('SimpleMessage', {
                            message: 'Código ya existente'
                        }, 'error_post_codBarras', false, 'sm');
                    }
                    else {
                        this.props.openDialog('SimpleMessage', {
                            message: 'error agregando codigo de barras'
                        }, 'error_post_codBarras', false, 'sm');
                    }
                },
                codigo,
                this.props.user);

        }
        else { //actualizar codigo
            url += '/' + this.state.id;
            putData(url, () => {
                this.props.hideDialog();
                this.props.okHandler(codigo);
            },
                (error) => {
                    if (error.response.data.startsWith('REPETIDO')) {
                        this.props.openDialog('SimpleMessage', {
                            message: 'Código ya existente'
                        }, 'error_put_codBarras', false, 'sm');
                    }
                    else {
                        this.props.openDialog('SimpleMessage', {
                            message: 'error modificando codigo de barras'
                        }, 'error_put_codBarras', false, 'sm');
                    }
                },
                codigo,
                this.props.user);
        }
    }

    render() {
        const { classes } = this.props;

        return (
            <div className={classes.root}>


                <FormControl className={classes.formControl}>
                    <TextField
                        id={'descr'}
                        label={'Código'}
                        placeholder={'Código'}
                        className={classes.textField}
                        margin="normal"
                        autoFocus
                        value={this.state.codBarras}
                        onChange={(event) => this.handleValueChange(event, 'codBarras')}
                    />
                </FormControl>

                <div className={classes.buttonsContainer}>
                    <Button className={classes.buttonsBottom} variant="contained" color="secondary" onClick={() => this.props.hideDialog()}>Cerrar</Button>
                    <Button className={classes.buttonsBottom} variant="contained" color="primary" onClick={() => {
                        this.updateCodigoBarras();
                    }
                    }>Guardar</Button>
                </div>
            </div>
        )
    }

};

EditCodigoBarras.propTypes = {
    codigo: PropTypes.object.isRequired,
    openDialog: PropTypes.func.isRequired,
    hideDialog: PropTypes.func.isRequired,
    okHandler: PropTypes.func.isRequired,
};


export default withStyles(styles, { withTheme: true })(EditCodigoBarras);